import { FN_GRID_ACTION_TYPE } from './fn-grid.constant';

/**
 * Grid Action Setup
 */
export class FnGridActionSetup {
	typeID: FN_GRID_ACTION_TYPE; //  ADD DELETE UPDATE CUSTOM
	actionID: string;
	isConditinal?: boolean;
	conditionalKey?: any; // row.something., header.something, globalCnf.something
	isRedirectAction?: boolean;
	redirectUrl?: string; // if isRedirectAction true
	actionHeaderID?: string; // action setup header key: like in employee update employe-> PrimaryKey is header ID
}
